import React from "react";
import Papa from "papaparse";
import "./UploadStep.css";

const UploadStep = ({ handleFileChange, setFile, uploadType }) => {
  const getSampleData = () => {
    switch (uploadType) {
      case "eventCreate":
        return [
          {
            event_name: "SCORE",
            start_date: "25-12-2024",
            end_date: "25-12-2024",
            start_time: "09:00 AM",
            end_time: "11:00 AM",
            event_level: "Prelims",
            event_round: "1",
            school_id: "SCHOOL123",
          },
        ];
      case "eventReschedule":
        return [
          {
            event_name: "SCORE",
            school_id: "SCHOOL123",
            start_date_time: "2025-01-24T10:00",
            end_date_time: "2025-01-24T10:45",
            level: "Prelims",
            round: "1",
          },
        ];
      case "eventDelete":
        return [
          {
            school_id: "SCHOOL123",
            start_date: "25-12-2024",
            end_date: "25-12-2024",
            start_time: "09:00 AM",
            end_time: "11:00 AM",
            level: "Prelims",
            round: "1",
          },
        ];
      case "studentRegister":
        return [
          {
            isd_code: "91",
            first_name: "John",
            last_name: "Doe",
            phone: "1234567890",
            grade: "10",
            school_id: "SCHOOL123",
          },
        ];
      case "uploadOfflineResponses":
        return [
          {
            first_name: "tester",
            last_name: "dummy",
            isd_code: "91",
            phone: "9000021123",
            grade: "10",
            school_id: "SCH1001000317",
            admission_id: "INX1PU6EE",
            Q1: "4",
            Q2: "3",
            Q3: "2",
            Q4: "1",
            Q5: "3",
            Q6: "3",
            Q7: "4",
            Q8: "3",
            Q9: "2",
            Q10: "1",
            Q11: "3",
            Q12: "3",
            Q13: "2",
            Q14: "1",
            Q15: "3",
            Q16: "3",
            Q17: "4",
            Q18: "3",
            Q19: "2",
            Q20: "1",
            login_id: "INX1PU6EE",
            exam_name: "NEET"
          },
        ];
      default:
        return [];
    }
  };

  const downloadSampleCSV = () => {
    const data = getSampleData();
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `sample_${uploadType}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFile(file);
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          handleFileChange(results.data);
        },
      });
    }
  };

  return (
    <div className="uploadModal-header1">
      <div className="upload-buttons">
        <div>
          <input
            type="file"
            id="fileInput"
            accept=".csv"
            onChange={handleFileUpload}
          />
          <label className="uploadInput" htmlFor="fileInput">
            UPLOAD FILE
          </label>
        </div>
        {uploadType && (
          <div>
            <button className="uploadInput" onClick={downloadSampleCSV}>
              DOWNLOAD SAMPLE
            </button>
          </div>
        )}
      </div>
      <div>
        <p>
          File size must be less than 20MB
          <br /> Supported format for upload- .csv
          <br /> Download sample CSV for reference
        </p>
      </div>
    </div>
  );
};

export default UploadStep;
